/**
 * Contains references for game assets implemented for Pawnshops
 */
export class PawnAssetStyle {
}
PawnAssetStyle.Background = {
    landscape: "BackgroundLandscape",
    portrait: "BackgroundPortrait",
};
PawnAssetStyle.Frame = {
    landscape: "Frame",
    portrait: "FramePortrait",
};
PawnAssetStyle.SpinsRemaining = {
    landscape: "SpinCounter",
};
//# sourceMappingURL=PawnAssetStyle.js.map